import {Component} from '@angular/core';

import {TranslateService} from '@ngx-translate/core';

import {UserService} from 'app/profile';
import {LocalSettingsService} from 'shared/local-settings/local-settings.service';
import {NavService} from 'shared/nav/nav.service';

import { HyphenateService } from 'shared/helpers/hyphenate.service';

@Component({
  selector: 'mode-page',
  templateUrl: 'mode-page.html',
  styleUrls: ['mode-page.scss'],
})
export class ModePage {

  public mode: string = '';

  constructor(
    public navService: NavService,
    public userService: UserService,
    private localSettingsService: LocalSettingsService,
  ) { }

  public onNextClick(): void {
    this.localSettingsService.set(LocalSettingsService.MODE, this.mode)
      .then(() => {
        this.navService.root('/login');
      });
  }

  public valueChanged(): void {
  }

  public onMoreInfoClick(mode: string): void {
    this.navService.push('mode-info/' + mode);
  }

}
